import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import ConceptosPagoCreate from "./ConceptosPagoCreate";
import axios from "axios";
import {
  ButtonGroup,
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Footer from "../../../layout/Footer/Footer";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Baja from "../../Baja";

function ListadoConceptosPago() {
  const { user } = useContext(AuthContext);
  const URL_CONCEPTOS_PAGO = process.env.REACT_APP_URL_CONCEPTOS_PAGO;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [conceptosPago, setConceptosPago] = useState([]);
  const [modal, setModal] = useState(false);
  const [concepto, setConcepto] = useState("");
  const toggle = () => setModal(!modal);
  const [text, setText] = useState(false);

  const [idEdit, setIdEdit] = useState()

  useEffect(() => {
    axios
      .get(URL_CONCEPTOS_PAGO, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allConceptosPago = response.data;
        setConceptosPago(allConceptosPago);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function editConceptoPago(event) {
    event.preventDefault();
    const URL_CONCEPTOS_PAGO_EDIT = `${process.env.REACT_APP_URL_CONCEPTOS_PAGO}/${idEdit}`;
    axios
      .patch(
        URL_CONCEPTOS_PAGO_EDIT,
        {
          concepto
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios
        .post(
          URL_LOGS,
          {
            tipo:'Editar Concepto de Pago',
            detalle: concepto,
            user: user.id
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
       .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(idEdit, concepto) {
        setConcepto(concepto);
        setIdEdit(idEdit);
        toggle();
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <div className="container">
        { user.menu_departamentos ? (
          <div className="row">
            {
              <div className="col-md-6 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <h3 align="center">Conceptos de Pago</h3>
                    <Table
                      size="sm"
                      striped
                      borderless
                      className="table-responsive-xl"
                    >
                      <thead>
                        <tr>
                          <th className="tituloTabla">Concepto</th>
                          <th className="tituloTabla">Editar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {conceptosPago
                          .sort((a, b) => (a.concepto > b.concepto ? 1 : -1))
                          .map((a) => {
                              return (
                                <tr>
                                  <td>{a.concepto}</td>
                                  <td>
                                    <Button
                                      color="info"
                                      id="Editar"
                                      size="sm"
                                      onClick={(e) => jalaInfo(a._id, a.concepto)}
                                    >
                                      <i class="far fa-edit"></i>{" "}
                                    </Button>

                                    {/* <Baja
                                      idStatus={a._id}
                                      is_active={a.is_active}
                                      URL_BAJA={
                                        process.env.REACT_APP_URL_CONCEPTOS_PAGO
                                      }
                                    /> */}


                                  </td>
                                </tr>
                              );
                          })}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            }
            <div className="col-md-6 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <ConceptosPagoCreate />
                </div>
              </div>
            </div>
          </div>
        ) : undefined}
      </div>
      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Concepto de Pago</ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Concepto</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={concepto}
            required
            onChange={(e) => {
              setConcepto(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editConceptoPago}>
            Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoConceptosPago;
